import ProjectImageAddon from './ProjectImageAddon.react';

import Config from '../../utils/Config';

class ProjectImage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            visible : false,
            loaded  : false,
            uuid    : uuid()
        };

        this.onScroll = this.onScroll.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {
        $('.project').on('scroll', this.onScroll);
    }

    componentWillUnmount() {
        $('.project').off('scroll', this.onScroll);
    }

    onScroll() {
        if (this.state.loaded)
            return;

        var uuid    = this.state.uuid;
        var project = this.props.project;
        var h       = $(window).height();

        if (!this.state.visible) {
            var offset      = $('#'+uuid).offset().top;

            if (offset < h - 100) {
                this.setState({ visible : true }, function() {
                    $('#'+uuid).animate({ top : 0, opacity : 1}, 600);
                })
            }

        } else {
            this.setState({ loaded : true });
        }
    }

    render() {
        var self    = this;
        var id      = this.props.id;
        var project = this.props.project;

        // console.log('project', project);

        return (
            <div
                className='project-image'
                id={this.state.uuid}>

                <img src={'/public/codi-studios/projects/'+id+'/'+project.img}
                    className='project-image__bground' />

                { project.extra_img !== false && this.state.loaded &&

                    <ProjectImageAddon
                        id={id}
                        project={project} />
                }

            </div>
        );
    }
}

export default ProjectImage;




// WEBPACK FOOTER //
// ./ui_src/app/components/portfolio/ProjectImage.react.jsx